module.exports = __webpack_public_path__ + "images/arrow-left-10557e.svg";